import React, { FC, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SearchInput, ISearchInput, ISearchOption } from '@sky-it-elections/design-system';

import { isValidUrl } from '../../utils/string-utils';

import { getAsyncOptions } from './search-input-helpers';

export interface ISearchInputWrapper {
  options: Array<ISearchOption>;
  placeholder?: string;
  title?: string;
  url?: string;
}

const onClickCallback = (e: ISearchOption) => {
  const dataUrl = e?.url as string;
  if (isValidUrl(dataUrl)) {
    window.location.assign(dataUrl); // Not testable with JEST mocks!
  }
};

const SearchInputWrapper: FC<ISearchInputWrapper> = ({ title, options, placeholder, url }) => {
  const [asyncOptions, setAsyncOptions] = useState<ISearchOption[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async (url: string) => {
      // UNCOMMENT if you need CUSTOM HEADERS for the REQUEST
      // const headers: Headers = getHeaders();
      // const request: Request = new Request(url, { method: 'GET', mode: 'cors', headers });
      const request: Request = new Request(url, { method: 'GET', mode: 'cors' });
      // console.log('municipality-search', { url, request, mocked });
      await getAsyncOptions(request, setLoading, setAsyncOptions);
    };

    if (url && isValidUrl(url)) {
      getData(url);
    }
  }, [url]); // eslint-disable-line react-hooks/exhaustive-deps

  const args: ISearchInput = {
    isLoading,
    title,
    options: url ? asyncOptions : options,
    placeholder,
  };
  // console.log('SearchInputWrapper', { title, options, placeholder, url });

  return (
    <div>
      <SearchInput {...args} onClickCallback={onClickCallback} />
    </div>
  );
};

SearchInputWrapper.propTypes = {
  options: PropTypes.arrayOf<ISearchOption>(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

SearchInputWrapper.defaultProps = {
  title: '',
  placeholder: undefined,
  url: undefined,
};

export default SearchInputWrapper;
